import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import { decodeToken } from 'utils/functions/jwt-token';
import { getMenuAndRoutes } from 'utils/functions/get-menu-and-routes';
import { Navigate } from 'react-router-dom';
import MainLayout from 'layout/MainLayout/index';
import Loadable from 'components/@ui/loader/Loadable';
import { lazy } from 'react';
import { buildProtectedRoutes } from 'utils/functions/build-protected-routes';
import { ROLES } from 'variables';
import PublicRoutes from 'pages/public/config';
import { ProfileRoutes } from 'pages/profile-management/config';
import { licenseRoutes } from 'pages/licenses/config';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const userData = decodeToken();
  // const { routes: dynamicRoutes } = getMenuAndRoutes(userData?.license);
  const { routes: dynamicRoutes } = getMenuAndRoutes('media');

  const dynamicChildren = buildProtectedRoutes([
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />,
          allowedRoles: [ROLES.Retailer, ROLES.Supplier],
          featureCode: 'personalization'
        }
      ]
    },
    ...ProfileRoutes,
    ...licenseRoutes,
    ...dynamicRoutes
  ]);

  const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [...dynamicChildren, { path: '*', element: <Navigate to="/404" replace /> }]
  };

  return useRoutes([LoginRoutes, MainRoutes, PublicRoutes]);
}
